// extracted by mini-css-extract-plugin
module.exports =  {"tooltip-box":"_0bc5e8de02--tooltip-box--K7_QW","tooltip-icon":"_0bc5e8de02--tooltip-icon--FmMU6"};